import * as React from 'react';

const MinesFooter = ({
  fill = '#4A4F4A',
  width = '24',
  height = '24'
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="17" height="2" viewBox="0 0 17 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 0.352418V1.65242L0 1.65242L5.68252e-08 0.352417L17 0.352418Z" fill="#EAEAEA" />
  </svg>
);

export default MinesFooter;
